import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Feather = createReactComponent("Feather", ["svg", defaultAttributes, [["path", {
  d: "M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5z",
  key: "4k6fqo"
}], ["line", {
  x1: "16",
  y1: "8",
  x2: "2",
  y2: "22",
  key: "zg5inx"
}], ["line", {
  x1: "17.5",
  y1: "15",
  x2: "9",
  y2: "15",
  key: "v1iq8k"
}]]]);
export default Feather;